<section class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0">
<div class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border" [ngClass]="{
            'shadow-lg border border-zinc-950/10 dark:border-white/10': source !== 'modal'
          }">
    <form [formGroup]="serviceAreaForm" (ngSubmit)="saveStaff()">
      <h1 *ngIf="source !== 'modal'" class="heading">
        {{serviceAreaId ? 'Edit' : 'Add'}}
      </h1>
      <hr *ngIf="source !== 'modal'" class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
      <section class="grid gap-4 sm:grid-cols-2">
        <div class="space-y-1">
          <label class="subheading">
            Title <span class="text-red-600">*</span>
          </label>
          <div>
            <div>
              <input formControlName="title" type="text" />
            </div>
            <div *ngIf="submitted && form.title.errors">
              <p  *ngIf="form.title.errors.required" class="pt-1 text-red-600 text-xs">
                Title is required
              </p>
            </div>
          </div>
        </div>
        <div class="space-y-1">
          <label class="subheading">
            Status
          </label>
          <div>
            <div>
              <select formControlName="isActive">
                <option [value]="true">Active</option>
                <option [value]="false">Inactive</option>
              </select>
            </div>
            <div *ngIf="submitted && form.isActive.errors">
              <p  *ngIf="form.isActive.errors.required" class="pt-1 text-red-600 text-xs">
               Status is required
              </p>
            </div>
          </div>
        </div>
        <div class="space-y-1">
          <label class="subheading">
              Description <span class="text-red-600">*</span>
          </label>
          <div>
              <div>
                  <textarea formControlName="description" name="" class="h-16"></textarea>
              </div>
              <div *ngIf="submitted && form.description.errors">
                <p  *ngIf="form.description.errors.required" class="pt-1 text-red-600 text-xs">
                    Description is required
                </p>
              </div>
          </div>
      </div>
      <div></div>
      <div class="space-y-1">
        <div
          class="w-full grid grid-cols-1 gap-x-4 gap-y-2 sm:grid-cols-6 border-2 border-main-base border-dashed p-4 rounded-lg">
          <div [formGroup]="zipCodeForm" novalidate class="sm:col-span-3">
            <div class="" show-errors>
              <label for="validationCustomUsername" class="subheading">Zip Code <span class="text-red-600">*</span></label>
              <div class="mt-1 flex gap-px">
                <input name="zoneToindex + 1" required type="text" class="" (input)="onInputChange($event)" formControlName="zipCode" />
  
                <button  type="button" (click)="addZipCode()"
                  class="btn btn-secondary inline-flex items-center rounded-r-md border border-l-0 border-main-primary bg-main-primary px-3 text-white sm:text-xs">Add
                </button>
              </div>
  
              <div *ngIf="formControl.zipCode.errors">
                <div *ngIf="formControl.zipCode.errors.required && zipCodeSubmitted " class="">
                  <p class="mt-2 text-xs text-red-600">
                    Zip Code is required
                  </p>
                </div>
              </div>
  
  
            </div>
          </div>
          <div class="sm:col-span-6">
            <div class="flex flex-wrap gap-1">
              <div *ngFor="let zipCode of form.zipCodes.value;  index as index" class="inline-flex w-auto">
                <div class="inline-flex w-auto">
                  <div class="flex gap-px" show-errors>
                    <div class="inline-flex items-center gap-x-0.5 rounded-md bg-gray-100 hover:bg-main-500 px-2 py-1 text-xs font-medium text-black ring-1 ring-inset ring-gray-300 space-x-1">
                      <span class="leading-0">
                        {{zipCode}}
                      </span>
                      <button type="button"
                        class="group relative h-4 w-4 rounded-full bg-gray-500 text-white flex justify-center items-center cursor-pointer"
                        (click)="removeZipCode(index)">
                        <span class="sr-only">Remove</span>
                        <svg viewBox="0 0 14 14"
                          class="h-3 w-3 stroke-white">
                          <path d="M4 4l6 6m0-6l-6 6" />
                        </svg>
                        <span class="absolute -inset-1"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
  
      </section>
      <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
      <section class="flex justify-end gap-4">
        <button type="submit" class="btn btn-secondary">
          {{serviceAreaId ? 'Update' : 'Create'}}
        </button>
      </section>
    </form>
  </div>
  
  
  
</section>